import { useState } from "react";
import { Check, Copy, Terminal } from "lucide-react";

export function InstallBlock() {
  const [copied, setCopied] = useState(false);
  const installCommand = "npm i codebridge-cli";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(installCommand);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-semibold text-neutral-500 uppercase tracking-widest mb-1 flex items-center gap-2">
        <Terminal size={14} />
        Quick Start
      </div>
      <div className="relative group flex items-center bg-[#111] text-white rounded p-4 pr-16 shadow-xl w-fit min-w-[300px] hover:shadow-2xl transition-all duration-300 border border-neutral-800">
        <code className="font-mono text-sm tracking-wide">
          <span className="text-neutral-500 select-none mr-4">$</span>
          {installCommand}
        </code>

        <button
          onClick={handleCopy}
          className="absolute right-2 p-2 rounded hover:bg-neutral-800 transition-colors duration-200 text-neutral-400 hover:text-white"
          aria-label="Copy install command"
        >
          {copied ? (
            <Check size={16} className="text-emerald-400" />
          ) : (
            <Copy size={16} />
          )}
        </button>
      </div>
    </div>
  );
}
